import {
  useCallback, useMemo, useState 
} from "react"

export const getPageParam = (searchParams, location) => {
  if (
    location.pathname === "/search.html" ||
        location.pathname.indexOf("reviews-page") > -1
  ) {
    return searchParams.get("p")
  }
 
  const {
    pathname 
  } = location

  const pathArr = pathname.split("/")

  const findIndex = pathArr.indexOf("p")

  if (findIndex > -1 && /^\d+$/.test(pathArr[findIndex + 1])) {
    return parseInt(pathArr[findIndex + 1], 10)
  }
    

  return 1
}

const defaultInitialPage = 1

export const usePagination = (props = {}) => {
  const searchParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '')

  const {
    initialTotalPages = 1
  } = props

  const [paginationState, setPaginationState] = useState({
    currentPage: typeof window !== 'undefined' ? (parseInt(getPageParam(searchParams, window.location), 10) || 1) : 1,
    totalPages: initialTotalPages || defaultInitialPage,
  })

  // use the location to hold state
  const setCurrentPage = useCallback((page) => {
    setPaginationState((prevState) => ({
      ...prevState,
      currentPage: page,
    }))
  }, [])

  const setTotalPages = useCallback((count) => {
    setPaginationState((prevState) => ({
      ...prevState,
      totalPages: count,
    }))
  }, [])

  const api = useMemo(
    () => ({
      setCurrentPage,
      setTotalPages,
    }),
    [setCurrentPage, setTotalPages]
  )

  return [paginationState, api]
}
